import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

// IMPORTANTE: Importar o provideFormlyCore
import { ConfigOption, FormlyModule, provideFormlyCore } from '@ngx-formly/core';

import { FormlyMaterialModule, withFormlyMaterial } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { FormlyMatInputModule } from '@ngx-formly/material/input';
import { FormlyMatRadioModule } from '@ngx-formly/material/radio';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

// Seus componentes e wrappers
import { addonsExtension } from './addons/addons.extension';
import { FormlyWrapperAddons } from './addons/addons.wrapper';
import {
  FormlyFieldCheckboxListComponent
} from './components/formly-field-checkbox-list/formly-field-checkbox-list.component';
import {
  FormlyFieldCurrencyTypeComponent
} from './components/formly-field-currency-type/formly-field-currency-type.component';
import {
  FormlyFieldMaskedTypeComponent
} from './components/formly-field-masked-type/formly-field-masked-type.component';
import { FormlyFieldRadioChipComponent } from './components/formly-field-radio-chip/formly-field-radio-chip.component';
import { FormlyFieldRadioListComponent } from './components/formly-field-radio-list/formly-field-radio-list.component';
import { FormlyFieldRadioComponent } from './components/formly-field-radio/formly-field-radio.component';
import { FlexLayoutType } from './components/formly-flex-layout';
import { FormlySelectImgComponent } from './components/formly-select-with-image';
import { PdfPasswordComponent } from './components/pdf-password/pdf-password.component';
import { SharedMaterialModule } from '../shared/shared-material.module';
import { GenericValidator } from './services/generic.validator';
import { ValidatorCpf } from './validators/validator-cpf';
import { ValidatorEmail } from './validators/validator-email';

// Mantenha a configuração separada, como definimos antes
export const FORMLY_CONFIG: ConfigOption = {
  wrappers: [{ name: 'addons', component: FormlyWrapperAddons }],
  extensions: [{ name: 'addons', extension: { onPopulate: addonsExtension } }],
  validators: [
    { name: 'email', validation: ValidatorEmail },
    { name: 'fieldMatch', validation: GenericValidator.fieldMatchValidator },
    { name: 'cpf', validation: ValidatorCpf },
    { name: 'cnpj', validation: GenericValidator.isValidCnpj },
  ],
  validationMessages: [
    { name: 'required', message: 'Este campo é obrigatório' },
    { name: 'minLength', message: GenericValidator.formlyMinLengthValidationMessage },
    { name: 'cpf', message: 'CPF inválido' },
    { name: 'email', message: 'E-mail inválido' }
  ],
  types: [
    { name: 'select-img', component: FormlySelectImgComponent },
    { name: 'flex-layout', component: FlexLayoutType },
    {
      name: 'radio',
      defaultOptions: { props: { appearance: 'outline' } },
    },
    { name: 'radio-list', component: FormlyFieldRadioListComponent },
    { name: 'radio-chip', component: FormlyFieldRadioChipComponent },
    { name: 'radio-custom', component: FormlyFieldRadioComponent },
    { name: 'checkbox-list', component: FormlyFieldCheckboxListComponent },
    {
      name: 'masked',
      component: FormlyFieldMaskedTypeComponent,
      defaultOptions: { props: { type: 'phone' } },
    },
    {
      name: 'currency',
      component: FormlyFieldCurrencyTypeComponent,
      defaultOptions: { props: {} },
    },
  ],
};

@NgModule({
  declarations: [
    FormlyFieldRadioChipComponent,
    FormlyFieldRadioComponent,
    FormlyFieldCheckboxListComponent,
    FormlyFieldRadioListComponent,
    FormlySelectImgComponent,
    PdfPasswordComponent,
    FormlyWrapperAddons,
    FlexLayoutType,
    FormlyFieldCurrencyTypeComponent,
    FormlyFieldMaskedTypeComponent,
  ],
  imports: [
    FormlyModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    SharedMaterialModule,
    FormlyMaterialModule,
    FormlyMatInputModule,
    FormlyMatDatepickerModule,
    FormlyMatRadioModule,
    FormlyMatToggleModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxFileDropModule,
    CurrencyMaskModule,
  ],

  providers: [
    // MUDANÇA AQUI: Injetando a configuração via Provider
    provideFormlyCore([FORMLY_CONFIG, ...withFormlyMaterial(),]),

    provideNgxMask(),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyMaterialModule,
    FormlyMatInputModule,
    FormlyMatDatepickerModule,
    FormlyFieldCurrencyTypeComponent,
  ],
})
export class FormModule {
}
